import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { Grid2, Tab, Tabs } from "@mui/material";

import ContainerLoading from "../components/ContainerLoading";
import PageHeader from "../components/PageHeader";
import IndicatorsCard from "../components/IndicatorsCard";
import CheckInTable from "../components/CheckInTable";
import StudentTable from "../components/StudentTable";

import { gympassListCheckIn } from "../services/gympass";

const Gympass = () => {
  const [value, setValue] = useState<"1" | "2">("1");

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryFn: gympassListCheckIn,
    queryKey: ["gympassListCheckIns"],
    initialData: {
      checkIns: [],
      students: [],
      checkInsOnMonth: 0,
      checkInsAmount: 0,
    },
  });

  const loading = isLoading || isFetching;

  return (
    <ContainerLoading loading={loading}>
      <Grid2 container spacing={2} padding={2}>
        <PageHeader
          title="Gympass"
          subtitle="Informações do Gympass (Wellhub) da sua academia."
        />

        <Grid2 size={12}>
          <IndicatorsCard
            data={[
              {
                id: 1,
                title: "Check-ins ( confirmados )",
                value: data?.checkInsAmount,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 4 },
              },
              {
                id: 2,
                title: "Check-ins confirmados neste mês",
                value: data.checkInsOnMonth,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 4 },
              },
              {
                id: 3,
                title: "Alunos Gympass",
                value: data.students.length,
                icon: "icon_school",
                size: { xs: 12, sm: 6, lg: 4 },
              },
            ]}
          />
        </Grid2>

        <Grid2 size={12}>
          <Tabs
            value={value}
            onChange={(_, v) => setValue(v)}
            textColor="inherit"
            variant="scrollable"
            scrollButtons="auto"
            sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}
          >
            <Tab label="CHECK-INS" value="1" />
            <Tab label="ALUNOS" value="2" />
          </Tabs>
        </Grid2>

        {value === "1" && (
          <Grid2 size={12}>
            <CheckInTable data={data.checkIns} refetch={refetch} />
          </Grid2>
        )}

        {value === "2" && (
          <Grid2 size={12}>
            <StudentTable data={data.students} refetch={refetch} />
          </Grid2>
        )}
      </Grid2>
    </ContainerLoading>
  );
};

export default Gympass;
